import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * Minimal switch (toggle) — shadcn pattern'ine yakın, Radix bağımlılığı yok.
 * Native checkbox üstüne CSS overlay ile rendering. Form submission'da
 * `name`/`value` gönderir, klavye/erişilebilirlik native davranışları korur.
 */
export interface SwitchProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  onCheckedChange?: (checked: boolean) => void;
}

export const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
  function Switch(
    { className, checked, onCheckedChange, onChange, disabled, ...props },
    ref,
  ) {
    return (
      <label
        className={cn(
          "relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full bg-input transition",
          "has-[input:checked]:bg-[color:var(--brand,theme(colors.primary))]",
          "has-[input:focus-visible]:ring-2 has-[input:focus-visible]:ring-ring has-[input:focus-visible]:ring-offset-2",
          disabled && "cursor-not-allowed opacity-50",
          className,
        )}
      >
        <input
          ref={ref}
          type="checkbox"
          className="peer sr-only"
          checked={checked}
          disabled={disabled}
          onChange={(e) => {
            onChange?.(e);
            onCheckedChange?.(e.target.checked);
          }}
          {...props}
        />
        <span
          className={cn(
            "pointer-events-none ms-0.5 block h-5 w-5 rounded-full bg-background shadow-sm transition-transform",
            "peer-checked:translate-x-5 rtl:peer-checked:-translate-x-5",
          )}
        />
      </label>
    );
  },
);
